import { EmptyState } from './ui';

export default function NoCompany() {
  return (
    <EmptyState
      title="Register your company first"
      body="This area opens once your company profile exists — it decides which documents we ask for and how you're rated."
      cta={{ label: 'Register company', to: '/company' }}
    />
  );
}
